import React, { useState } from 'react';
import { Container, Typography, Tabs, Tab, Box } from '@mui/material';
import UsersAndRoles from './UsersAndRoles';
import AccessControlsAndLogs from './AccessControlsAndLogs';

const UserManagement = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="xl">
      <Typography  mt={3} variant="h4" gutterBottom>User Management</Typography>
      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab label="Users and Roles" />
        <Tab label="Access Controls and Logs" />
      </Tabs>
      <Box mt={3}>
        {activeTab === 0 && <UsersAndRoles />}
        {activeTab === 1 && <AccessControlsAndLogs />}
      </Box>
    </Container>
  );
};

export default UserManagement;
